import React from "react";
import style from "./style/cards.module.scss";
import icon from "../../assets/book.png";

const SelectedCardContent = React.memo(({ title, file, goBack }) => {
    return (
        <div className={style.cardInfo}>
            <h1>{title}</h1>
            <div className={style.cardInfoBox}>
                <div className={style.cardInfoLine}/>
                <div className={style.cardInfoText}>
                    <img src={icon} alt="icon"/>
                    <h3>Նկարագրություն</h3>
                    <div className={style.hr}/>
                    <p></p>
                    <div className={style.pdfViewer}>
                        <iframe src={file} title="PDF Viewer"/>
                    </div>
                    {/*<div className={style.videoViewer}>*/}
                        {/*<iframe*/}
                        {/*    src={video}*/}
                        {/*    title="YouTube video player"*/}
                        {/*    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"*/}
                        {/*    allowFullScreen*/}
                        {/*></iframe>*/}
                    {/*</div>*/}

                </div>
            </div>
        </div>
    );
});

export default SelectedCardContent;
